function importImg(r) {
  let images = {};
  r.keys().map(item => { images[item.replace('./', '')] = r(item); });
  return images;
}

export const images = importImg(require.context('../img', false, /\.(png|jpe?g|svg)$/));